import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';
import WetSlider from './WetSlider.js';

class DistortionEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.effect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                <div>
                  <EffectParameterSlider
                        effectNumber={this.props.effectNumber}
                        automation={this.props.automation}
                        name='Distortion'
                        parameter={this.state.effect.distortionParameter}
                        lfoEnabled={true}
                        sequencerEngine={this.props.sequencerEngine}
                        selectedParameter={this.props.selectedParameter}
                        onParameterChanged={this.props.onParameterChanged}
                        isParameter={true}
                        step={0.01}
                        max={1}
                        min={0}
                        />
                      <WetSlider
                        effectNumber={this.props.effectNumber}
                            sequencerEngine={this.props.sequencerEngine}
                        automation={this.props.automation}
                        selectedParameter={this.props.selectedParameter}
                         onParameterChanged={this.props.onParameterChanged}
                            effect={this.state.effect}/>
                 </div>} 
            </div>
        );
    }
}

export default DistortionEffect;
